import DisplayModeEditor from './DisplayModeEditor';

export default DisplayModeEditor;
